const COLORS = {
	PRIMARY: "#E7450F",
	SECONDARY: "#004263",
	HOVER: "#0CB3A1",
	BODY: "#292D32",
	BODY70: "#3A3F44",
	ALT1: "#1890FF",
	ALT2: "#FDC453",
	ALT3: "#EF5C62",
	BACK: "#F7F9FB",
	BACK70: "#F5F5F5",
	WHITE: "#ffffff",
	ANTDBLUE: "#1362E1",
	GREY: "#bcb9b9",
	RED: "#ff0000",
	DARKGREY: "grey",
	ORANGE: "orange",
	BLUE: "#1890ff",
	GREEN: "#389E0D",
};
export default COLORS;
